//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import ProfileData from '~/components/profile/mixins/ProfileData'
import ProfileOverviewLazy from "~/components/profile/mixins/ProfileOverviewLazy"

import { BImg } from 'bootstrap-vue'

export default {

    name: 'ProfileGallery',

    mixins: [ProfileData, ProfileOverviewLazy],

    components: { BImg },

    props: {
        company: {
        },
        destination: {
        },
    },

    data() {
        return {
            images: []
        }
    },

    async fetch() {
        this.getData()
    },

    methods: {

        openGallery(index) {
            this.$bus.$emit('openCompanyGallery', this.images, index)
        },

        async getData() {

            if(this.visible === false) {
                return
            }

            try {
                const response = await this.$store.dispatch('profile/GET_IMAGES', this.company.id)
                this.images = response.data
            } catch (e) {
                console.log(e)
                this.$logger.captureException(e)
            }

            this.isReady = true

        }

    },

    computed: {

        imagesLimited() {
            return this.images.slice(0, 3)
        }

    }

}

